module.exports = __webpack_public_path__ + "b6a0a1d5b8094d5e54f3cf214a5462af.pdf";